<template>
  <div>
    <el-row :gutter="24" type="flex">
      <el-col :span="8">
        <CardContainer class="top-left-div">
          <div class="img tasks"></div>
          <div class="count">
            <div class="label">{{ $t('Fota.executeTask') }}</div>
            <div class="value">{{ taskNumber }}</div>
            <div class="clearfix"></div>
          </div>
        </CardContainer>
        <CardContainer class="top-left-div" style="margin-top: 24px;">
          <div class="img upgrade"></div>
          <div class="count">
            <div class="label">{{ $t('Fota.upDevice') }}</div>
            <div class="value">{{ upDevice }}</div>
            <div class="clearfix"></div>
          </div>
        </CardContainer>
      </el-col>
      <el-col :span="16">
        <CardContainer class="top-right-div">
          <div class="box">
            <div class="wrap now">
              <div class="name">{{ newestTask | format }}</div>
              <div class="time">{{ getTime(newestTaskDate, 'YYYY-MM-DD') }}</div>
              <div class="label">{{ $t('Fota.newestTask') }}</div>
            </div>
            <div class="wrap max" style="margin-left: 24px;">
              <div class="name">{{ taskNameOfMaximumDevice | format }}</div>
              <div class="number">{{ maximumDeviceCount }}</div>
              <div class="label">{{ $t('Fota.maximumDeviceCount') }}</div>
            </div>
          </div>
        </CardContainer>
      </el-col>
    </el-row>
    <CardContainer style="margin-top: 24px;">
      <div v-if="addRole">
        <div style="margin-bottom: 16px;">
          <hl-button @click="handleSet" size="small">
            {{ $t('Common.create') }}
          </hl-button>
        </div>
        <CommonForm @search="formSearch" :form-json="formjson" />
      </div>
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
        :hadCalculatedOptWidthFlag="true"
        :operationColWidthNumber="200"
      >
      </CommonTable>
      <Set v-if="visible" :visible.sync="visible" @handleAdd="handleAdd" />
      <Dialog
        type="DTU"
        :targetType="targetType"
        :destVersionList="destVersionList"
        @refresh="formSearch"
        v-if="showModel"
        :showModel.sync="showModel"
      />
    </CardContainer>
  </div>
</template>

<script>
import formjson from './Model/Formjson.TaskDtu'
import tablejson from './Model/Tablejson.TaskDtu'
import formTableMixin from '@/mixins/formTableMixin'
import { getRoleByOperationCode } from '@/authorized'
import { formatTime, format } from '@/utils/utils'

import Set from './Set'
import Dialog from './Dialog'
export default {
  name: 'Task',
  filters: {
    format
  },
  mixins: [formTableMixin],
  props: {
    role: {
      type: Array
    }
  },
  components: {
    Set,
    Dialog
  },
  data() {
    return {
      taskNumber: 0,
      upDevice: 0,
      newestTask: '',
      newestTaskDate: '',
      taskNameOfMaximumDevice: '',
      maximumDeviceCount: 0,
      formjson,
      tablejson,
      operation: [
        {
          name: this.$t('Common.detail'),
          icon: 'icon-detail_16',
          type: 'detail',
          hide: () => {
            return !this.detailRole
          }
        },
        {
          name: this.$t('Common.pass'),
          icon: 'icon-adopt',
          type: 'pass',
          width: 80,
          hide: (row) => {
            return !this.approveRole || row.status !== 'EXAMINE_WAIT'
          }
        },
        {
          name: this.$t('Common.reject'),
          icon: 'icon-reject',
          type: 'reject',
          width: 80,
          hide: (row) => {
            return !this.approveRole || row.status !== 'EXAMINE_WAIT'
          }
        },
        {
          name: this.$t('Common.enable'),
          icon: 'icon-enable',
          type: 'open',
          hide: (row) => {
            return !this.openStopRole || row.status !== 'DISABLE'
          }
        },
        {
          name: this.$t('Common.disabled'),
          icon: 'icon-disable',
          type: 'stop',
          hide: (row) => {
            return !this.openStopRole || row.status !== 'ENABLE'
          }
        },
        {
          name: this.$t('Common.delete'),
          icon: 'icon-del_16',
          type: 'delete',
          hide: (row) => {
            return !this.deleteRole || row.status !== 'EXAMINE_REJECT'
          }
        }
      ],
      visible: false,
      showModel: false,
      queryApi: this.$api.fota.task_page,
      row: {},
      targetType: '',
      destVersionList: []
    }
  },
  computed: {
    /********* 权限 ***********/
    // this.role 计算属性通过mixins: [getRoleFromPath] 注入
    // 导出权限
    // 新建
    addRole() {
      let val = getRoleByOperationCode(this.role, 'add')
      return val ? val.isPermission == 'Y' : false
    },
    // 编辑
    updateRole() {
      let val = getRoleByOperationCode(this.role, 'update')
      return val ? val.isPermission == 'Y' : false
    },
    // 删除
    deleteRole() {
      let val = getRoleByOperationCode(this.role, 'del')
      return val ? val.isPermission == 'Y' : false
    },
    // 详情
    detailRole() {
      let val = getRoleByOperationCode(this.role, 'detail')
      return val ? val.isPermission == 'Y' : false
    },
    // 审批
    approveRole() {
      let val = getRoleByOperationCode(this.role, 'approve')
      return val ? val.isPermission == 'Y' : false
    },
    // 启停用
    openStopRole() {
      let val = getRoleByOperationCode(this.role, 'open_stop')
      return val ? val.isPermission == 'Y' : false
    }
    /********* 权限 ***********/
  },
  mounted() {
    // 升级目标版本下拉框
    let params = {
      firmwareType: 'DTU',
      enable: true
    }
    this.$ajax.get(this.$api.fota.firmware_list, params).then((res) => {
      this.destVersionList = res.data
    })
    // 统计信息
    this.getData()
  },
  methods: {
    formSearch(data, pageObj) {
      if (!data) {
        data = this.cacheData
      }
      data.firmwareType = 'DTU'
      this.search(data, pageObj, this.queryApi)
    },
    getData() {
      let params = {
        firmwareType: 'DTU'
      }
      this.$ajax.get(this.$api.fota.task_statistic, params).then((res) => {
        this.taskNumber = res.data.totalCount
        this.upDevice = res.data.awaitCount
        this.newestTask = res.data.newestTask
        this.taskNameOfMaximumDevice = res.data.taskNameOfMaximumDevice
        this.newestTaskDate = res.data.newestTaskDate
        this.maximumDeviceCount = res.data.maximumDeviceCount
      })
    },
    handleSet() {
      this.visible = true
    },
    handleAdd(showModel, targetType) {
      this.targetType = targetType
      this.showModel = showModel
    },
    handleDetail(row) {
      this.$router.push('/fota/task/detail?id=' + row.id + '&type=DTU')
    },
    handlePass(row) {
      this.$confirm(`${this.$t('Fota.approvePassTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: `${this.$t('Common.pass')}`,
        cancelButtonText: `${this.$t('Common.cancel')}`,
        type: 'warning'
      })
        .then(() => {
          let params = {
            taskId: row.id
          }
          this.$ajax
            .post(this.$api.fota.task_approve, params)
            .then(() => {
              this.$message.success(`${this.$t('Fota.approvePassTips2')}`)
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleReject(row) {
      this.$confirm(`${this.$t('Fota.approveRejectTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: `${this.$t('Common.reject')}`,
        cancelButtonText: `${this.$t('Common.cancel')}`,
        type: 'warning'
      })
        .then(() => {
          let params = {
            taskId: row.id
          }
          this.$ajax
            .post(this.$api.fota.task_reject, params)
            .then(() => {
              this.$message.success(`${this.$t('Fota.approveRejectTips2')}`)
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleOpen(row) {
      this.$confirm(`${this.$t('Fota.enableTaskTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: `${this.$t('Common.enable')}`,
        cancelButtonText: `${this.$t('Common.cancel')}`,
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.fota.task_start, params)
            .then(() => {
              this.$message.success(`${this.$t('Fota.enableTaskTips2')}`)
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleStop(row) {
      this.$confirm(`${this.$t('Fota.disableTaskTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: `${this.$t('Common.disabled')}`,
        cancelButtonText: `${this.$t('Common.cancel')}`,
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.fota.task_stop, params)
            .then(() => {
              this.$message.success(`${this.$t('Fota.disableTaskTips2')}`)
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleDelete(row) {
      this.$confirm(`${this.$t('Common.operationTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: `${this.$t('Common.confirm')}`,
        cancelButtonText: `${this.$t('Common.cancel')}`,
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.fota.task_remove, params)
            .then(() => {
              this.$message.success(`${this.$t('Common.delSuccess')}`)
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'detail':
          this.handleDetail(row)
          break
        case 'pass':
          this.handlePass(row)
          break
        case 'reject':
          this.handleReject(row)
          break
        case 'open':
          this.handleOpen(row)
          break
        case 'stop':
          this.handleStop(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
      }
    },
    getTime(val, format) {
      return formatTime(val, format)
    }
  }
}
</script>

<style lang="scss">
.top-left-div {
  height: 100px;
  .el-card__body {
    padding-top: 14px !important;
  }
  .img {
    float: left;
    margin-top: 12px;
    width: 48px;
    height: 48px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    vertical-align: top;
    &.tasks {
      background-image: url('../../../assets/tasks.png');
    }
    &.upgrade {
      background-image: url('../../../assets/upgrade.png');
    }
  }
  .count {
    float: left;
    margin-left: 24px;
    .label {
      line-height: 24px;
      font-size: 16px;
      color: #666666;
    }
    .value {
      line-height: 56px;
      font-family: Barlow-SemiBold;
      font-size: 48px;
      font-weight: 600;
      color: #333333;
    }
  }
}
.top-right-div {
  height: 224px;
  .el-card__body {
    height: 100%;
  }
  .box {
    display: flex;
    height: 100%;
    .wrap {
      position: relative;
      flex: 1;
      padding: 24px;
      height: 100%;
      background-repeat: no-repeat;
      background-position: left center;
      background-size: cover;
      border-radius: 15px;
      &.now {
        background-image: url('../../../assets/total_times_bg.jpg');
        .name {
          color: #ffffff;
        }
        .time {
          margin-top: 8px;
          padding: 0 8px;
          width: max-content;
          height: 22px;
          line-height: 22px;
          font-size: 14px;
          font-weight: 600;
          color: #2e85f7;
          background-image: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0.89) 100%);
          border-radius: 9.5px;
        }
        .label {
          color: #d4eaff;
        }
      }
      &.max {
        background-image: url('../../../assets/normal_bg.jpg');
        .name {
          color: #333333;
        }
        .number {
          margin-top: 8px;
          padding: 0 8px;
          width: max-content;
          height: 22px;
          line-height: 22px;
          font-size: 14px;
          font-weight: 600;
          color: #ffffff;
          background: #00cbd3;
          border-radius: 9.5px;
        }
        .label {
          color: #666666;
        }
      }
      .name {
        line-height: 32px;
        font-size: 24px;
        font-weight: 600;
      }
      .label {
        position: absolute;
        left: 24px;
        bottom: 24px;
        font-size: 14px;
      }
    }
  }
}
</style>
